import { Action } from "./Actions";
import { Point } from "./Point";

export class Transition {
    public id: string;
    public name = "";
    public to: string;
    public condition: string = "";
    public isActive = false;
    public points: Point[];
    public setId: string;
    public actions: Action[];

    constructor(id: string, to: string, points: Point[], setId: string, actions: Action[]) {
        this.id = id;
        this.to = to;
        this.points = points;
        this.setId = setId;
        this.actions = actions;
    }
}
